import React, {useContext} from 'react';
import {Box, Dialog, Grid, Typography} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import SecondaryButton from '../../../common/StyledComponents/SecondaryButton';
import {NewProjectContext} from '../utils/NewProjectContext';

const style = (theme: $TSFixMe) => ({
  root: {
    padding: 20,
  },

  or: {
    fontSize: 12,
    margin: 10,
    color: 'rgba(0,0,0,0.6)',
  },
});

const NewProjectChoice = (props: $TSFixMe) => {
  const {classes} = props;
  const {setProject, setNewProjectStep} = useContext(NewProjectContext);

  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
  const parsedProject = JSON.parse(localStorage.getItem('rfp'));

  return (
    <Dialog
      open={props.open}
      PaperProps={{
        style: {
          borderRadius: 10,
        },
      }}>
      <Grid
        className={classes.root}
        container
        direction={'column'}
        alignItems="center">
        <Box mb={3}>
          <Typography variant="subtitle1" fontSize={18}>
            You have a project in progress{parsedProject?.title && ':'}
          </Typography>
          <Typography
            variant="subtitle1"
            style={{fontWeight: 'bold', textAlign: 'center', fontSize: 18}}>
            {parsedProject?.title}
          </Typography>
        </Box>
        <Box mb={1}>
          <SecondaryButton
            size="small"
            onClick={() => {
              setProject(parsedProject);
              if (localStorage.getItem('prePackagedProject')) {
                props.chooseProjectTemplate(
                  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | null' is not assignable... Remove this comment to see the full error message
                  JSON.parse(localStorage.getItem('prePackagedProject'))
                    .templateKey,
                );
              } else {
                setNewProjectStep(1);
              }
              props.setNewProjectChoiceOpen(false);
            }}>
            Continue on this project
          </SecondaryButton>
        </Box>

        <Grid container justifyContent="center" alignItems="center">
          <span style={{borderTop: '1px solid rgba(0,0,0,.1)', width: '40%'}} />
          <Typography variant="subtitle2" className={classes.or}>
            OR
          </Typography>
          <span style={{borderTop: '1px solid rgba(0,0,0,.1)', width: '40%'}} />
        </Grid>

        <Box mt={1} mb={2}>
          <SecondaryButton
            size="small"
            onClick={() => props.startProjectFromScratch()}>
            Create project from scratch
          </SecondaryButton>
        </Box>
      </Grid>
    </Dialog>
  );
};

export default withStyles(style)(NewProjectChoice);
